import {timeUtil} from '../../../util'

var methodsHelper = {
  init: {
    // 初始化页面控制器
    initPageControl: function (pageParams, pageControl, approveData, pageData, cardConfig) {
      // 页面访问许可
      pageControl.accessAllowed = false
      // 页面路由参数
      pageParams.operateType = null
      pageParams.identity = null
      pageParams.approvalStep = 0
      pageParams.appCode = null
      // 页面控制器
      pageControl.current.operateType = 0
      pageControl.current.operateTypePreview = false
      pageControl.current.operateTypeApprove = false
      pageControl.current.operateTypeModify = false
      pageControl.current.identity = 0
      pageControl.current.identityApprover = false
      pageControl.current.approvalStep = 0
      pageControl.current.approvalStepFirst = false
      pageControl.current.approvalStepReview = false
      pageControl.current.approvalStepFinal = false
      pageControl.current.approvalStepReconsider = false
      pageControl.current.approvalStepContract = false
      pageControl.current.approvalStepGps = false
      pageControl.current.approvalStepMortgage = false
      pageControl.current.approvalStepAfterFinal = false
      pageControl.current.forSearch = false
      pageControl.current.isCompanyLicense = true
      pageControl.current.isMarried = true
      pageControl.current.hasGuaranteeInfo = true
      // 明显显示和展开所有
      cardConfig.collapseButton.flag = true
      cardConfig.collapseButton.text.current = String(cardConfig.collapseButton.text.hide)
      cardConfig.detailButton.showDetails = true
      cardConfig.detailButton.text.current = String(cardConfig.detailButton.text.hide)
      // 小眼睛
      pageControl.eyes.proposer.idno = true
      pageControl.eyes.proposer.mobile = true
      pageControl.eyes.guarantee.idno = true
      pageControl.eyes.guarantee.mobile = true
      pageControl.eyes.relative.idno = true
      pageControl.eyes.relative.mobile = true
      pageControl.eyes.eContactMobile = true
      pageControl.eyes.eContactsMobile = true
      pageControl.eyes.carIdentify = true
      pageControl.eyes.carSaleIdno = true
      pageControl.eyes.repAccountIdno = true
      pageControl.eyes.repAccountNo = true
      pageControl.eyes.repAccountMobile = true
      pageControl.eyes.recAccountNo = true
      pageControl.eyes.recAccountCard = true
      // 审批数据
      for (let field in approveData.formMortgage) {
        approveData.formMortgage[field] = null
      }
      approveData.form.backReasonBackToPrevious = null
      // 页面数据
      pageData = {}
    },
    // 参数校验
    validatePageParams: function (route, pageControl) {
      // 1 非空校验
      if (route.params === undefined) {
        console.error('route.params is undefined')
        return false
      }
      if (route.params.operateType === undefined) {
        console.error('route.params.operateType is undefined')
        return false
      }
      if (route.params.identity === undefined) {
        console.error('route.params.identity is undefined')
        return false
      }
      if (route.params.approvalStep === undefined) {
        console.error('route.params.approvalStep is undefined')
        return false
      }
      if (route.params.appCode === undefined) {
        console.error('route.params.appCode is undefined')
        return false
      }
      // 2 参数值-非法校验
      if (pageControl.operateType[route.params.operateType] === undefined) {
        console.error('route.params.operateType is unavailable')
        return false
      }
      if (pageControl.identity[route.params.identity] === undefined) {
        console.error('route.params.identity is unavailable')
        return false
      }
      if (pageControl.approveStep[route.params.approvalStep] === undefined) {
        console.error('route.params.approvalStep is unavailable')
        return false
      }
      // 3 参数逻辑-非法校验
      // 3.1 运营人员 & 非预览操作 => 非法操作
      if (pageControl.identity[route.params.identity] === pageControl.identity.operator && (pageControl.operateType[route.params.operateType] !== pageControl.operateType.preview || pageControl.approveStep[route.params.approvalStep] !== pageControl.approveStep.for_search)) {
        console.error('Illegal Request!! Operator only allowed to Preview the For_Search refs, change your operateType to preview and approveStep to for_search then it would work')
        return false
      }
      // 3.2 编辑操作 & 非复审阶段 => 非法操作
      if (pageControl.operateType[route.params.operateType] === pageControl.operateType.modify && pageControl.approveStep[route.params.approvalStep] !== pageControl.approveStep.review) {
        console.error('Illegal Request!! No Modify on approveStep except Review, change your approveStep to review then it would work')
        return false
      }
      // 3.3 综合查询 & 非预览操作 => 非法操作
      if (pageControl.approveStep[route.params.approvalStep] === pageControl.approveStep.for_search && pageControl.operateType[route.params.operateType] !== pageControl.operateType.preview) {
        console.error('Illegal Request!! No For_Search on operateType except Preview, change your operateType to preview then it would work')
        return false
      }
      return true
    },
    // 保存参数
    savePageParam: function (pageParams, route) {
      pageParams.operateType = route.params.operateType // 操作类型
      pageParams.identity = route.params.identity // 身份标识
      pageParams.approvalStep = route.params.approvalStep // 信审流程阶段
      pageParams.appCode = route.params.appCode // 订单号
    },
    // 操作相关设置
    operateTypeRelateSettings: function (pageControl, cardConfig) {
      if (pageControl.current.operateType === pageControl.operateType.preview) {
        // 操作类型 - 是否预览操作
        pageControl.current.operateTypePreview = true
      } else if (pageControl.current.operateType === pageControl.operateType.approve) {
        // 操作类型 - 是否审批操作
        pageControl.current.operateTypeApprove = true
        // 操作类型 - 如果是审批操作，则设置preview为true
        pageControl.current.operateTypePreview = true
      } else if (pageControl.current.operateType === pageControl.operateType.modify) {
        // 操作类型 - 是否编辑操作
        pageControl.current.operateTypeModify = true
      }

      // 操作类型 - 如果预览属性开启，则显示顶部的detailsButton
      if (pageControl.current.operateTypePreview) {
        cardConfig.detailButton.text.current = cardConfig.detailButton.text.hide
        cardConfig.collapseButton.text.current = cardConfig.collapseButton.text.hide
      }
    },
    // 身份相关设置
    identityRelateSettings: function (pageControl) {
      if (pageControl.current.identity === pageControl.identity.approver) {
        // 操作人身份 - 是否审批人
        pageControl.current.identityApprover = true
      }
    },
    // 流程阶段相关设置
    approvalStepRelateSettings: function (pageControl, apiUrl, cardConfig, pageTitle, pageParams, approveData, enumStore) {
      // 【重点】pageControl.current.approvalStep 仅用于init中逻辑判断，其他逻辑均用对应的Boolean类型做判断（原因：1.代码简介；2.终审和终审复议时该值是相同的）
      if (pageControl.current.approvalStep === pageControl.approveStep.first) {
        // 信审流程阶段 - 是否初审阶段
        pageControl.current.approvalStepFirst = true
        // 返回页面
        apiUrl.returnPage.current = apiUrl.returnPage.first
        // 提交接口
        apiUrl.approve.currentObj = apiUrl.approve.first
        // 审批决定
        approveData.currentDecisionArray = enumStore.state['初审审批决定']
      } else if (pageControl.current.approvalStep === pageControl.approveStep.review) {
        // 信审流程阶段 - 是否复审阶段
        pageControl.current.approvalStepReview = true
        // 返回页面
        apiUrl.returnPage.current = apiUrl.returnPage.review
        // 提交接口
        apiUrl.approve.currentObj = apiUrl.approve.review
        // 审批决定
        approveData.currentDecisionArray = enumStore.state['复审审批决定']
      } else if (pageControl.current.approvalStep === pageControl.approveStep.final) {
        // 信审流程阶段 - 是否终审阶段
        pageControl.current.approvalStepFinal = true
        // 返回页面
        apiUrl.returnPage.current = apiUrl.returnPage.final
        // 提交接口
        apiUrl.approve.currentObj = apiUrl.approve.final
        // 审批决定
        approveData.currentDecisionArray = enumStore.state['终审审批决定']
      } else if (pageControl.current.approvalStep === pageControl.approveStep.reconsider) {
        // 信审流程阶段 - 是否终审阶段 - 终审复议
        pageControl.current.approvalStepReconsider = true
        // 返回页面
        apiUrl.returnPage.current = apiUrl.returnPage.final
        // 提交接口
        apiUrl.approve.currentObj = apiUrl.approve.reconsider
        // 审批决定
        approveData.currentDecisionArray = enumStore.state['终审复议审批决定']
      } else if (pageControl.current.approvalStep === pageControl.approveStep.contract) {
        // 信审流程阶段 - 是否签约审阶段
        pageControl.current.approvalStepContract = true
        // 返回页面
        apiUrl.returnPage.current = apiUrl.returnPage.contract
        // 提交接口
        apiUrl.approve.currentObj = apiUrl.approve.contract
        // 审批决定
        approveData.currentDecisionArray = enumStore.state['签约审批决定']
      } else if (pageControl.current.approvalStep === pageControl.approveStep.mortgage) {
        // 信审流程阶段 - 是否抵押审批
        pageControl.current.approvalStepMortgage = true
        // 返回页面
        apiUrl.returnPage.current = apiUrl.returnPage.mortgage
        // 提交接口
        apiUrl.approve.currentObj = apiUrl.approve.mortgage
      } else if (pageControl.current.approvalStep === pageControl.approveStep.for_search) {
        // 综合查询
        pageControl.current.forSearch = true
        apiUrl.returnPage.current = apiUrl.returnPage.forSearch
      } else if (pageControl.current.approvalStep === pageControl.approveStep.gps) {
        // GPS查询
        pageControl.current.approvalStepGps = true
        // 返回页面
        apiUrl.returnPage.current = apiUrl.returnPage.gps
        // 提交接口
        apiUrl.approve.currentObj = apiUrl.approve.gps
      }

      // 设置编辑页的返回页
      if (pageControl.current.operateTypeModify) {
        apiUrl.returnPage.current = apiUrl.returnPage.modify + pageParams.appCode
      }

      // 信审流程阶段 - 是否终审阶段之后
      if (!(pageControl.current.approvalStep in [pageControl.approveStep.first, pageControl.approveStep.review, pageControl.approveStep.final])) {
        pageControl.current.approvalStepAfterFinal = true
      }

      // 如果当前为终审复议，设置step为final [这里决定了终审和终审复议时approveStep值相同]
      if (pageControl.current.approvalStepReconsider) {
        pageControl.current.approvalStep = pageControl.approveStep.final
      }

      // 页面标题 - 当前
      if (pageControl.current.operateTypeModify) {
        cardConfig.collapseButton.text.current = cardConfig.collapseButton.text.hide
        pageTitle.current = pageTitle.modify
      } else {
        pageTitle.current = pageTitle[pageParams.approvalStep]
      }
    },
    // 订单状态校验 - 对应的状态进入对应的审批页
    validateOrderStatus: function (pageData, pageControl, message) {
      // 变量命名allowXxxStatus 表示允许访问xxx审批详情的订单状态，特殊说明allowGpsStatusAndGPSStatus，表示allowGpsStatus + GPSStatus 含两个状态数据：订单状态+GPS状态
      // 进入初审审批页：07
      let allowFirstStatus = ['07']
      // 进入复审审批页：09 10
      let allowReviewStatus = ['09', '10']
      // 进入终审审批页：13
      let allowFinalStatus = ['13']
      // 进入终审复议审批页：13
      let allowReconsiderStatus = ['13']
      // 进入签约审批页：16 17
      let allowContractStatus = ['16', '17']
      // 进入GPS审批页：14 15 16 17 18 19 20 21 22 23 24 gpsStatus 是03
      let allowGpsStatus = ['14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24']
      let allowGpsStatusAndGPSStatus = ['03']
      // 进入抵押审批页：32
      let allowMortgage = ['32']

      // 开始校验
      if (pageControl.current.approvalStepFirst && allowFirstStatus.includes(pageData.orderBaseInfo.status)) {
        return true
      } else if (pageControl.current.approvalStepReview && allowReviewStatus.includes(pageData.orderBaseInfo.status)) {
        return true
      } else if (pageControl.current.approvalStepFinal && allowFinalStatus.includes(pageData.orderBaseInfo.status)) {
        return true
      } else if (pageControl.current.approvalStepReconsider && allowReconsiderStatus.includes(pageData.orderBaseInfo.status)) {
        return true
      } else if (pageControl.current.approvalStepContract && allowContractStatus.includes(pageData.orderBaseInfo.status)) {
        return true
      } else if (pageControl.current.approvalStepGps && allowGpsStatus.includes(pageData.orderBaseInfo.status) && allowGpsStatusAndGPSStatus.includes(pageData.orderBaseInfo.gpsStatus)) {
        return true
      } else if (pageControl.current.approvalStepMortgage && allowMortgage.includes(pageData.orderBaseInfo.status)) {
        return true
      } else if (pageControl.current.forSearch) {
        return true
      }
      message.error('非法访问 - 当前订单状态不允许进入此页面')
      pageControl.accessAllowed = false
      return false
    },
    // 下拉框数据展示 - 数据类型转换(all_status_or_types -> toString)
    enumValuesToString: function (pageData) {
      // 审批流程
      pageData.orderBaseInfo.flowSeq = pageData.orderBaseInfo.flowSeq !== null ? String(pageData.orderBaseInfo.flowSeq) : null
      // 车牌类型
      pageData.orderBaseInfo.isCompanyLicense = pageData.orderBaseInfo.isCompanyLicense !== null ? String(pageData.orderBaseInfo.isCompanyLicense) : null
      // 驾驶员与主贷人关系
      pageData.orderProppserInfo.relationDFl = pageData.orderProppserInfo.relationDFl !== null ? String(pageData.orderProppserInfo.relationDFl) : null
      // 现工作单位规模
      pageData.proppserWorkInfo.nowUnitScale = pageData.proppserWorkInfo.nowUnitScale !== null ? String(pageData.proppserWorkInfo.nowUnitScale) : null
      // 软料类型
      pageData.orderCarInfo.fuelType = pageData.orderCarInfo.fuelType !== null ? String(pageData.orderCarInfo.fuelType) : null
      // 车辆用途
      pageData.orderCarInfo.purpose = pageData.orderCarInfo.purpose !== null ? String(pageData.orderCarInfo.purpose) : null
      // 还款期限
      pageData.orderLoanInfo.aLoanPeriods = pageData.orderLoanInfo.aLoanPeriods !== null ? String(pageData.orderLoanInfo.aLoanPeriods) : null
      pageData.orderBaseInfo.rLoanPeriods = pageData.orderBaseInfo.rLoanPeriods !== null ? String(pageData.orderBaseInfo.rLoanPeriods) : null
      // 利率档位
      pageData.orderLoanInfo.rateLevel = pageData.orderLoanInfo.rateLevel !== null ? String(pageData.orderLoanInfo.rateLevel) : null
      pageData.orderBaseInfo.rRateLevel = pageData.orderBaseInfo.rRateLevel !== null ? String(pageData.orderBaseInfo.rRateLevel) : null
      // GPS安装方式
      if (pageData.carGpsInfoList && pageData.carGpsInfoList.length > 0) {
        pageData.carGpsInfoList.forEach(gps => {
          gps.gpsInstallWay = gps.gpsInstallWay !== null ? String(gps.gpsInstallWay) : null
        })
      }
      // 驾驶人驾驶凭证
      pageData.orderProppserInfo.isDriverLicense = pageData.orderProppserInfo.isDriverLicense !== null ? String(pageData.orderProppserInfo.isDriverLicense) : null
      // 过户凭证
      pageData.orderLoanInfo.transferVoucher = pageData.orderLoanInfo.transferVoucher !== null ? String(pageData.orderLoanInfo.transferVoucher) : null
      // 异地购车补充资料
      pageData.orderLoanInfo.nonLocalMaterial = pageData.orderLoanInfo.nonLocalMaterial !== null ? String(pageData.orderLoanInfo.nonLocalMaterial) : null
    },
    // 省市区转换
    dealCityData: function (pageData, pageHelperData) {
      // 申请人
      pageHelperData.area.proposer.home = [pageData.orderProppserInfo.province, pageData.orderProppserInfo.city, pageData.orderProppserInfo.district]
      pageHelperData.area.proposer.now = [pageData.orderProppserInfo.nowProvince, pageData.orderProppserInfo.nowCity, pageData.orderProppserInfo.nowDistrict]
      pageHelperData.area.proposer.work = [pageData.proppserWorkInfo.nowUnitProvince, pageData.proppserWorkInfo.nowUnitCity, pageData.proppserWorkInfo.nowUnitDistrict]
      // 担保人
      pageHelperData.area.guarantee.home = [pageData.guaranteeInfo.province, pageData.guaranteeInfo.city, pageData.guaranteeInfo.district]
      pageHelperData.area.guarantee.now = [pageData.guaranteeInfo.nowProvince, pageData.guaranteeInfo.nowCity, pageData.guaranteeInfo.nowDistrict]
      pageHelperData.area.guarantee.work = [pageData.guaranteeInfo.nowUnitProvince, pageData.guaranteeInfo.nowUnitCity, pageData.guaranteeInfo.nowUnitDistrict]
      // 配偶
      pageHelperData.area.relative.home = [pageData.orderRelativeInfo.province, pageData.orderRelativeInfo.city, pageData.orderRelativeInfo.district]
      pageHelperData.area.relative.now = [pageData.orderRelativeInfo.nowProvince, pageData.orderRelativeInfo.nowCity, pageData.orderRelativeInfo.nowDistrict]
      // 收款账户
      pageHelperData.area.loanAccount = [pageData.orderLoanAccountInfo.bankProvince, pageData.orderLoanAccountInfo.bankCity]
    },
    // 业务数据相关逻辑处理
    bizDataLogic: function (pageControl, pageData) {
      // 车牌类型：0 是私牌，非0是公牌
      pageControl.current.isCompanyLicense = (pageData.orderBaseInfo.isCompanyLicense !== '0')
      // 是否已婚：1 已婚，0 未婚，2 离异，3 丧偶
      pageControl.current.isMarried = (pageData.orderProppserInfo.marriage === '1')
      // 是否有担保人：0 否，1 是
      pageControl.current.hasGuaranteeInfo = (pageData.orderProppserInfo.isAssure === '1')
      // 访问许可
      pageControl.accessAllowed = true

      /// 复审和终审 审批逻辑初始化
      // 如果是非已婚 - 是否配偶共签默认否，且不可以编辑
      if (!pageControl.current.isMarried) {
        pageData.orderBaseInfo.isSpouseSign = '0'
      }
      // 如果是没有担保人 -> 是否担保共签默认否，且不可以编辑
      if (!pageControl.current.hasGuaranteeInfo) {
        pageData.orderBaseInfo.isGuaranteedSign = '0'
      }
    },
    // 初始化审批决定
    approveDecision: function (pageControl, approveData, pageParams, apiUrl, httpClient) {
      // 置空
      approveData.form.type = null

      // 表单验证规则
      if (pageControl.current.approvalStepMortgage) { // 抵押审批
        // 审批信息块
        httpClient.get(apiUrl.approve.mortgage.loadData, {params: {appCode: pageParams.appCode}}).then(response => {
          approveData.formMortgage = response.data.data
        })
        // 设置默认审批操作和表单验证规则
        approveData.rules.current = approveData.rules.mortgagePass
      } else { // 其他审批
        approveData.rules.current = approveData.rules.cancel
      }
    }
  },
  calculateFee: {
    prepareParams: function (appCode, pageData) {
      var params = {}
      params.appCode = appCode
      params.carLoanAmount = pageData.orderBaseInfo.rCarloanAmount
      params.loanPeriods = pageData.orderBaseInfo.rLoanPeriods
      params.carFirstBook = pageData.orderCarInfo.carFirstBook
      params.carMiles = pageData.orderCarInfo.carMiles
      params.carNewPrice = pageData.orderCarInfo.carNewPrice
      params.comRate = pageData.orderLoanInfo.aComRate
      params.lifeRate = pageData.orderLoanInfo.alifeInsuranceRate
      params.dealerCode = pageData.orderBaseInfo.dealerCode
      params.gpsLevel = pageData.orderLoanInfo.gpsLevel
      params.isHouse = pageData.orderLoanInfo.isHouse
      params.isLcv = pageData.orderLoanInfo.isLcv
      params.isOld = pageData.orderCarInfo.isOld
      params.productCode = pageData.orderBaseInfo.productCode
      params.rateLevel = pageData.orderLoanInfo.rateLevel
      params.lifeLevel = pageData.orderLoanInfo.lifeInsuranceLevel
      params.salePrice = pageData.orderLoanInfo.salePrice
      return params
    },
    validateParams: function (params) {
      var validRules = {
        'appCode': '订单号不能为空',
        'carLoanAmount': '车辆贷款金额不能为空',
        'loanPeriods': '贷款期限不能为空',
        'carFirstBook': '二手车首次上牌时间不能为空',
        'carMiles': '二手车里程不能为空',
        'carNewPrice': '新车参考价不能为空',
        'comRate': '平台费率不能为空',
        'lifeRate': '人身保险利率不能为空',
        'dealerCode': '门店编码不能为空',
        'gpsLevel': 'GPS档位不能为空',
        'isHouse': '是否提供房产不能为空',
        'isLcv': '车类不能为空',
        'isOld': '是否二手车不能为空',
        'productCode': '产品编码不能为空',
        'rateLevel': '利率档位不能为空',
        'lifeLevel': '人身保险档位不能为空',
        'salePrice': '车辆实际销售金额不能为空'
      }
      var result = {inValid: false, msg: 'ok'}
      if (params !== null) {
        for (let field in params) {
          if (params[field] === null || params[field] === '') {
            result.inValid = true
            result.msg = validRules[field]
            return result
          }
        }
      }
      return result
    },
    dealResponse: function (reply, pageData, pageHelperData) {
      pageData.orderBaseInfo.rAccountFee = reply.accountAmount
      pageData.orderBaseInfo.rlifeInsuranceCostFee = reply.alifeInsuranceCostFee
      pageData.orderBaseInfo.rlifeInsuranceProfitFee = reply.alifeInsuranceProfitFee
      pageData.orderLoanInfo.alifeInsuranceRate = reply.alifeInsuranceRate
      pageData.orderBaseInfo.rBusinessInsurance = reply.businessInsurance
      pageData.orderBaseInfo.rComFee = reply.comFee
      pageData.orderLoanInfo.disaRate = reply.disaRate
      pageData.orderLoanInfo.discountE = reply.discountE
      pageData.orderLoanInfo.discountTrueE = reply.discountTrueE
      pageData.orderBaseInfo.rExtendCost = reply.extendCost
      pageHelperData.form.extendName = reply.extendName
      pageData.orderLoanInfo.gpsCount = reply.gpsCount
      pageData.orderBaseInfo.rGpsFee = reply.gpsFee
      pageData.orderLoanInfo.gpsPro = reply.gpsPro
      pageData.orderBaseInfo.gpsRebate = reply.gpsRebate
      pageData.orderBaseInfo.rInitPayment = reply.initPayment
      pageData.orderBaseInfo.rInitScale = reply.initScale
      pageData.orderLoanInfo.lifeInsuranceLevel = reply.lifeInsuranceLevel
      pageData.orderBaseInfo.rLoanAmount = reply.loanAmount
      pageData.orderBaseInfo.rLoanRate = reply.loanRate
      // pageData.orderBaseInfo.rGrossInterest = reply.preInterestAmount // 不保存前置总利息 20180626
      pageData.orderBaseInfo.serFinRebate = reply.rebateFee
      pageData.orderBaseInfo.rSecureFee = reply.secureFee
      pageData.orderBaseInfo.rTaxPrice = reply.taxPrice
      pageData.orderBaseInfo.rTrafficInsurance = reply.trafficInsurance
    }
  },
  calculateMonthPay: {
    prepareParams: function (pageData) {
      var params = {}
      params.amount = pageData.orderBaseInfo.rLoanAmount
      params.periods = pageData.orderBaseInfo.rLoanPeriods
      params.yearRate = pageData.orderBaseInfo.rLoanRate
      params.productCode = pageData.orderBaseInfo.productCode
      return params
    }
  },
  calculateCarAge (pageData) {
    pageData.orderCarInfo.oldCarAge = timeUtil.monthsToNow(pageData.orderCarInfo.carFirstBook)
    // 计算二手车价格浮动率
    if (pageData.orderCarInfo.oldCarAge >= 0 && pageData.orderCarInfo.oldCarAge <= 36) {
      pageData.orderCarInfo.floatingPro = 20
    } else if (pageData.orderCarInfo.oldCarAge >= 37 && pageData.orderCarInfo.oldCarAge <= 60) {
      pageData.orderCarInfo.floatingPro = 10
    } else {
      pageData.orderCarInfo.floatingPro = 0
    }
  },
  saveReplyData: {
    prepareParams: function (pageParams, pageData) {
      var params = {}
      params.appCode = pageParams.appCode
      params.rCarLoanAmount = pageData.orderBaseInfo.rCarloanAmount
      params.rLoanPeriods = pageData.orderBaseInfo.rLoanPeriods
      params.rAccountFee = pageData.orderBaseInfo.rAccountFee
      params.rRateLevel = pageData.orderBaseInfo.rRateLevel
      params.rComFee = pageData.orderBaseInfo.rComFee
      params.rYanbaoFee = pageData.orderBaseInfo.rYanbaoFee
      params.rGpsFee = pageData.orderBaseInfo.rGpsFee
      params.rLoanRate = pageData.orderBaseInfo.rLoanRate
      params.preloanRate = pageData.orderBaseInfo.rLoanRate
      params.rInitPayment = pageData.orderBaseInfo.rInitPayment
      params.rInitScale = pageData.orderBaseInfo.rInitScale
      params.rDiscountTrueE = pageData.orderBaseInfo.rDiscountTrueE
      params.rExtendCost = pageData.orderBaseInfo.rExtendCost
      params.rTaxPrice = pageData.orderBaseInfo.rTaxPrice
      params.rBusinessInsurance = pageData.orderBaseInfo.rBusinessInsurance
      params.rTrafficInsurance = pageData.orderBaseInfo.rTrafficInsurance
      params.rSecureFee = pageData.orderBaseInfo.rSecureFee
      params.isSpouseSign = pageData.orderBaseInfo.isSpouseSign
      params.isGuaranteedSign = pageData.orderBaseInfo.isGuaranteedSign
      params.rlifeInsuranceProfitFee = pageData.orderBaseInfo.rlifeInsuranceProfitFee
      params.rlifeInsuranceCostFee = pageData.orderBaseInfo.rlifeInsuranceCostFee
      params.serFinRebate = pageData.orderBaseInfo.serFinRebate
      // params.rGrossInterest = pageData.orderBaseInfo.rGrossInterest // 不保存前置总利息 20180626
      params.gpsRebate = pageData.orderBaseInfo.gpsRebate
      params.gpsCount = pageData.orderLoanInfo.gpsCount
      params.gpsPro = pageData.orderLoanInfo.gpsPro
      return params
    }
  },
  modifyOrder: {
    prepareParams: function (pageParams, pageData, pageHelperData) {
      var modifyParam = {}
      // 订单号
      modifyParam.appCode = pageParams.appCode
      // 申请人信息
      modifyParam.proppserInfoParam = Object.assign({}, pageData.orderProppserInfo)
      modifyParam.proppserInfoParam.cardProductCode = pageData.spdBusinessInfo.cardProductCode
      modifyParam.proppserInfoParam.cardProductName = pageData.spdBusinessInfo.cardProductName
      modifyParam.proppserInfoParam.email = pageData.spdBusinessInfo.email
      modifyParam.proppserInfoParam.firstWorkTime = pageData.proppserWorkInfo.firstWorkTime
      modifyParam.proppserInfoParam.nowUnitAddress = pageData.proppserWorkInfo.nowUnitAddress
      modifyParam.proppserInfoParam.nowCompany = pageData.proppserWorkInfo.nowCompany
      modifyParam.proppserInfoParam.nowUnitKind = pageData.proppserWorkInfo.nowUnitKind
      modifyParam.proppserInfoParam.nowUnitScale = pageData.proppserWorkInfo.nowUnitScale
      modifyParam.proppserInfoParam.nowUnitTel = pageData.proppserWorkInfo.nowUnitTel
      modifyParam.proppserInfoParam.nowWorkYear = pageData.proppserWorkInfo.nowWorkYear

      // 申请人省/市/区
      // 户籍
      modifyParam.proppserInfoParam.province = pageHelperData.area.proposer.home.length > 0 ? pageHelperData.area.proposer.home[0] : null
      modifyParam.proppserInfoParam.city = pageHelperData.area.proposer.home.length > 1 ? pageHelperData.area.proposer.home[1] : null
      modifyParam.proppserInfoParam.district = pageHelperData.area.proposer.home.length > 2 ? pageHelperData.area.proposer.home[2] : null
      // 现居
      modifyParam.proppserInfoParam.nowProvince = pageHelperData.area.proposer.now.length > 0 ? pageHelperData.area.proposer.now[0] : null
      modifyParam.proppserInfoParam.nowCity = pageHelperData.area.proposer.now.length > 1 ? pageHelperData.area.proposer.now[1] : null
      modifyParam.proppserInfoParam.nowDistrict = pageHelperData.area.proposer.now.length > 2 ? pageHelperData.area.proposer.now[2] : null
      // 工作单位
      modifyParam.proppserInfoParam.nowUnitProvince = pageHelperData.area.proposer.work.length > 0 ? pageHelperData.area.proposer.work[0] : null
      modifyParam.proppserInfoParam.nowUnitCity = pageHelperData.area.proposer.work.length > 1 ? pageHelperData.area.proposer.work[1] : null
      modifyParam.proppserInfoParam.nowUnitDistrict = pageHelperData.area.proposer.work.length > 2 ? pageHelperData.area.proposer.work[2] : null
      // 车辆信息
      modifyParam.carInfoParam = Object.assign({}, pageData.orderCarInfo)
      modifyParam.carInfoParam.carHomePrice = pageData.orderCarInfo.carHomePrice
      modifyParam.carInfoParam.floatingPro = pageData.orderCarInfo.floatingPro
      modifyParam.carInfoParam.vinIdentifyChe300Id = pageData.orderCarInfo.vinIdentifyChe300Id

      // 担保人信息
      modifyParam.guaranteeInfoParam = Object.assign({}, pageData.guaranteeInfo)
      // 担保人省/市/区
      // 户籍
      modifyParam.guaranteeInfoParam.province = pageHelperData.area.guarantee.home.length > 0 ? pageHelperData.area.guarantee.home[0] : null
      modifyParam.guaranteeInfoParam.city = pageHelperData.area.guarantee.home.length > 1 ? pageHelperData.area.guarantee.home[1] : null
      modifyParam.guaranteeInfoParam.district = pageHelperData.area.guarantee.home.length > 2 ? pageHelperData.area.guarantee.home[2] : null
      // 现居
      modifyParam.guaranteeInfoParam.nowProvince = pageHelperData.area.guarantee.now.length > 0 ? pageHelperData.area.guarantee.now[0] : null
      modifyParam.guaranteeInfoParam.nowCity = pageHelperData.area.guarantee.now.length > 1 ? pageHelperData.area.guarantee.now[1] : null
      modifyParam.guaranteeInfoParam.nowDistrict = pageHelperData.area.guarantee.now.length > 2 ? pageHelperData.area.guarantee.now[2] : null
      // 工作单位
      modifyParam.guaranteeInfoParam.nowUnitProvince = pageHelperData.area.guarantee.work.length > 0 ? pageHelperData.area.guarantee.work[0] : null
      modifyParam.guaranteeInfoParam.nowUnitCity = pageHelperData.area.guarantee.work.length > 1 ? pageHelperData.area.guarantee.work[1] : null
      modifyParam.guaranteeInfoParam.nowUnitDistrict = pageHelperData.area.guarantee.work.length > 2 ? pageHelperData.area.guarantee.work[2] : null
      // 配偶信息
      modifyParam.relativesInfoParam = Object.assign({}, pageData.orderRelativeInfo)
      // 配偶省/市/区
      // 户籍
      modifyParam.relativesInfoParam.province = pageHelperData.area.relative.home.length > 0 ? pageHelperData.area.relative.home[0] : null
      modifyParam.relativesInfoParam.city = pageHelperData.area.relative.home.length > 1 ? pageHelperData.area.relative.home[1] : null
      modifyParam.relativesInfoParam.district = pageHelperData.area.relative.home.length > 2 ? pageHelperData.area.relative.home[2] : null
      // 现居
      modifyParam.relativesInfoParam.nowProvince = pageHelperData.area.relative.now.length > 0 ? pageHelperData.area.relative.now[0] : null
      modifyParam.relativesInfoParam.nowCity = pageHelperData.area.relative.now.length > 1 ? pageHelperData.area.relative.now[1] : null
      modifyParam.relativesInfoParam.nowDistrict = pageHelperData.area.relative.now.length > 2 ? pageHelperData.area.relative.now[2] : null
      // 备注信息
      modifyParam.loanRemarks = pageData.orderBaseInfo.loanRemarks // 复审审批备注
      modifyParam.fyRemarks = pageData.orderBaseInfo.fyRemarks // 复议备注
      return modifyParam
    }
  },
  evaluatePrice: {
    prepareParams: function (dialogData, pageData, pageHelperData, _enumStore) {
      dialogData.getC300EvaluationPrice.apiParams.dealerCode = pageData.orderBaseInfo.dealerCode
      dialogData.getC300EvaluationPrice.apiParams.vin = pageData.orderCarInfo.carIdentify
      dialogData.getC300EvaluationPrice.apiParams.mileage = pageData.orderCarInfo.carMiles
      dialogData.getC300EvaluationPrice.apiParams.firstregtime = timeUtil.parseTime(pageData.orderCarInfo.carFirstBook, '{y}-{m}-{d}')
      dialogData.getC300EvaluationPrice.apiParams.che300Mid = pageData.orderCarInfo.vinIdentifyChe300Id
      dialogData.getC300EvaluationPrice.apiParams.mid = pageData.orderCarInfo.carStyleId
      dialogData.getC300EvaluationPrice.apiParams.color = _enumStore.state['车辆颜色'][pageData.orderCarInfo.carColor]
    }
  },
  reset: {
    approveForm: function (form) {
      // 公用审批数据
      form.passType = null
      form.passReason = null
      form.refuseType = null
      form.refuseReason = null
      form.cancelType = null
      form.riskCode = null
      form.riskName = null
      form.backCode = null
      form.backType = null
      form.backReason = null
      form.remarks = null
      form.nextUserId = null
      form.nextTrueName = null
      form.backReasonBackToPrevious = null
      // 签约数据
      form.carResult = null
      form.isCreditReport = null
      form.authCh = null
      form.pledModelId = null
      form.isVipContract = null
      form.modelIds = null
      form.transferRegDate = null
    },
    mortgageApproveForm: function (form) {
      form.cancelReason = null
      form.postLoanStatus = null
    }
  }
}

export {
  methodsHelper
}



// WEBPACK FOOTER //
// ./src/assets/js/page/approval/helper/orderDetails.vue.methods.helper.js